export const SYSTEM = `{
    id
    type
    data
    createdAt
    updatedAt
    __typename
  }`
